"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureNoNullables = void 0;
const lodash_omitby_1 = __importDefault(require("lodash.omitby"));
/**
 * This function should be used temporarily. The client is setting values to `null`
 * when it should have been `undefined`. This function is a helper for that.
 * Once the game is fixed to not save more nulls, we should deprecate the function
 */
const omitByDeep = (obj, fn) => {
    // _.omitBy(object, (v) => v === null);
    return Object.keys(obj).reduce((res, cur) => {
        let value = obj[cur];
        const isObj = typeof value === 'object';
        const isArray = Array.isArray(value);
        const isArrayOfObjs = isArray && typeof value[0] === 'object';
        if (isArrayOfObjs) {
            value = value.map((o) => omitByDeep(o, fn));
        }
        return {
            ...res,
            [cur]: isObj && !isArray ? omitByDeep((0, lodash_omitby_1.default)(value, fn), fn) : value,
        };
    }, {});
};
const ensureNoNullables = (story) => {
    return omitByDeep(story, (v) => v === null);
};
exports.ensureNoNullables = ensureNoNullables;
//# sourceMappingURL=ensureNoNullables.js.map